import React from 'react';

// Country Club Golf Crest Logo Icon
export function CountryClubCrest({ className = "w-6 h-6 text-emerald-400" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M12 2L3 7v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5z" fill="currentColor" fillOpacity="0.15" />
      <path d="M12 6v10M9 13l3 3 3-3" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="7" r="1.5" fill="currentColor" />
    </svg>
  );
}

// Golf Flag / Pin Icon
export function GolfFlagIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
      <path d="M4 22V3M4 3l13 4-13 4" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="4" cy="22" r="1" fill="currentColor" />
    </svg>
  );
}

// PS2 Memory Card (8MB) Icon
export function Ps2MemoryCardIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm2 3v2h4V6H6zm6 0v2h6V6h-6zm-6 4v10h12V10H6z" opacity="0.9" />
      <rect x="8" y="12" width="2" height="4" rx="0.5" fill="currentColor" opacity="0.4" />
      <rect x="11" y="12" width="2" height="4" rx="0.5" fill="currentColor" opacity="0.4" />
      <rect x="14" y="12" width="2" height="4" rx="0.5" fill="currentColor" opacity="0.4" />
    </svg>
  );
}

// PS2 DualShock Controller Icon
export function Ps2ControllerIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
      <rect x="2" y="6" width="20" height="12" rx="4" />
      <circle cx="7" cy="11" r="1.5" />
      <circle cx="17" cy="11" r="1.5" />
      <path d="M10 14h4" strokeLinecap="round" />
    </svg>
  );
}

// Network / Ethernet DNAS Adapter Icon
export function NetworkAdapterIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9 12h6M12 9v6" strokeLinecap="round" />
      <circle cx="7" cy="7" r="1" fill="currentColor" />
      <circle cx="17" cy="7" r="1" fill="currentColor" />
    </svg>
  );
}

// CRT Monitor / Screen Icon
export function CrtMonitorIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
      <rect x="2" y="4" width="20" height="14" rx="3" />
      <path d="M8 21h8M12 18v3" strokeLinecap="round" />
      <line x1="5" y1="9" x2="19" y2="9" strokeOpacity="0.4" />
      <line x1="5" y1="13" x2="19" y2="13" strokeOpacity="0.4" />
    </svg>
  );
}

// Copy Clipboard Icon
export function CopyIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
}

// Checkmark Icon
export function CheckIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Search Magnifier Icon
export function SearchIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
      <circle cx="11" cy="11" r="8" />
      <path d="M21 21l-4.35-4.35" strokeLinecap="round" />
    </svg>
  );
}

// Users / Players Group Icon
export function UsersIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

// Trophy / Match Leaderboard Icon
export function TrophyIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16M12 17v5M8 2h8v7a4 4 0 0 1-8 0V2z" />
    </svg>
  );
}

// Food / Dining Plate & Fork Icon
export function DiningPlateIcon({ className = "w-4 h-4" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
      <path d="M18 8v13M14 8v13M21 8c0 2.5-1.5 5-3 5s-3-2.5-3-5" strokeLinecap="round" />
      <path d="M3 2v7c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V2M6 11v10" strokeLinecap="round" />
    </svg>
  );
}

// Chevron Down / Up Icon
export function ChevronIcon({ className = "w-4 h-4", direction = "down" }) {
  const rotates = {
    down: "rotate-0",
    up: "rotate-180",
    left: "-rotate-90",
    right: "rotate-90",
  };
  return (
    <svg className={`${className} transition-transform duration-200 ${rotates[direction] || ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
